import styled, { css } from 'styled-components';

export default styled.div.attrs({
  className: 'plan-packages',
})`
  ${({ theme, twoProducts, metadata }) => {
    const { colors, media } = theme;
    const { products } = metadata || {};
    const tabsEnabled = products?.card?.categoryTabsEnabled === 'true' || false;
    return css`
      .page-header {
        margin-top: 0;
        margin-bottom: 50px;

        .h1 {
          line-height: 1.2;
        }

        .subheader {
          &__text {
            max-width: 30ch;
          }
        }
        .edit-address {
          padding-top: 32px;
        }
        ${media.tablet.up} {
          display: flex;
          justify-content: space-between;
        }
        ${media.tablet.only} {
          &__titles {
            flex: 0 0 352px;
          }
        }
        ${media.mobile.down} {
          &__titles {
            text-align: center;
          }
        }
      }

      .filter-container {
        display: flex;
        ${media.mobile.down} {
          flex-direction: column;
        }
      }
      ${media.mobile.down} {
        .label {
          border-bottom: 1px solid ${colors.primary.gray};
          text-align: center;
          margin-bottom: 10px;
          padding-bottom: 20px;
        }
      }
      .product-filters {
        ${media.tablet.up} {
          &__phone {
            .label {
              white-space: nowrap;
              font-weight: 500;
            }
          }
        }
        ${media.mobile.down} {
          &__phone {
            .label {
              white-space: nowrap;
            }
          }
        }
      }
      .featureSuper {
        vertical-align: super;
        font-size: 11px;
        display: inline;
      }

      .banner {
        flex: 0 0 415px;

        &__icon-wrapper {
          display: flex;
          align-items: center;
          padding: 16px;
        }
      }

      .plan-packages {
        /* Apply styles only when the tabbed experience is enabled */
        &__tab-wrapper {
          .plan-packages__tabs {
            display: flex;
            justify-content: space-between;
            margin: 0;
            width: 100%;

            ${media.mobile.only} {
              margin: 0 auto 32px;
              width: 342px;
            }

            ${media.tablet.only} {
              margin: 0 auto;
              width: 720px;
            }
          }

          .plan-packages__tab {
            border: none;
            background: none;
            font-size: 14px;
            line-height: 22px;
            font-weight: 700;
            cursor: pointer;
            width: 50%;

            ${media.tablet.up} {
              font-size: 18px;
              line-height: 26px;
            }

            &.active {
              border-bottom: 2px solid ${colors.primary.red};
              padding-bottom: 12px;

              ${media.tablet.up} {
                border-bottom: 4px solid ${colors.primary.red};
              }
            }

            &.inactive {
              border-bottom: 2px solid ${colors.secondary.pumice};
              padding-bottom: 12px;

              ${media.tablet.up} {
                border-bottom: 4px solid ${colors.secondary.pumice};
              }
            }
          }

          .plan-packages__cards {
            /* Adds space for banner that gets enabled below cards */
            @media(min-width: 600px) and (max-width: 1440px) {
              margin: auto 0 60px;
            }
          }

          .swiper {
            .swiper-wrapper {
              @media(min-width: 1440px) {
                justify-content: center;
              }
            }
          }

          .swiper-navigation {
            bottom: -50px;
          }

          .swiper-button-next {
            right: calc((100% - 100px) / 2);
          }

          .swiper-button-prev {
            left: calc((100% - 100px) / 2);
          }

          .swiper-pagination-bullet {
            background-color: ${colors.primary.white};
            border: 2px solid ${colors.primary.gravity};
            opacity: 1;
          }

          .swiper-pagination-bullet.swiper-pagination-bullet-active {
            border: none;
            background-color: ${colors.primary.red};
          }
        }

        &__action-bar {
          margin-bottom: 80px;

          ${media.tablet.up} {
            display: flex;
            justify-content: space-between;
            .product-filters {
              flex: 1 1 auto;
            }
          }
          ${media.tablet.down} {
            margin-bottom: 5rem;
            padding-left: 1rem;
            padding-right: 1rem;
          }

          ${media.mobile.down} {
            display: flex;
            flex-direction: column;
            gap: 32px;
            align-items: center;
          }
        }
        &__cards {
          position: relative;
          align-items: flex-start;
          display: flex;

          &:not(.w-theme) {
            gap: 1.5rem;
            margin-bottom: 44px;
          }
          @media(max-width: 767px) {
            // Fix scrolling issue on mobile
            .swiper.swiper-vertical {
              touch-action: pan-y;
            }

            &--stacked {
              display: block;
              padding-left: 1rem;
              padding-right: 1rem;

              .swiper-wrapper {
                display: flex;
                flex-direction: column;
                transform: none !important;
              }

              .swiper-slide {
                flex: 1;
              }
            }

            &--overflow-visible .swiper-navigation {
              display: none;
            }
          }
          @media(min-width: 481px) {
            &--overflow-visible .swiper-navigation {
              bottom: 1rem;
            }
            &--overflow-visible .swiper {
              margin-bottom: 4rem;
            }
          }
          @media(min-width: 768px) {
            &--overflow-visible .swiper-slide {
              max-width: 260px;
            }
          }
          @media(min-width: 1024px) {
            &--overflow-visible .swiper-slide {
              flex: 0 0 calc(40% - 1.25rem);
            }
          }
          @media(min-width: 1280px) {
            &--overflow-visible {
              position: relative;

              &:before,
              &:after {
                content: '';
                position: absolute;
                height: calc(100% - 5.5rem);
                width: 100%;
                z-index: 2;
                left: 0;
                pointer-events: none;
              }
            }
            &--overflow-visible .swiper-navigation {
              .swiper-button-prev {
                left: 0;
              }

              .swiper-button-next {
                right: 0;
              }
            }
          }
          @media(min-width: 1024px) {
            &--overflow-visible .swiper {
              &::before,
              &::after {
                content: '';
                position: absolute;
                z-index: 5;
                top: 0;
                left: 0;
                bottom: 0;
                width: 150px;
                background: linear-gradient(
                  to right,
                  hsl(0, 0%, 100%) 0%,
                  hsla(0, 0%, 100%, 0.987) 9.2%,
                  hsla(0, 0%, 100%, 0.951) 16.7%,
                  hsla(0, 0%, 100%, 0.896) 22.7%,
                  hsla(0, 0%, 100%, 0.825) 27.6%,
                  hsla(0, 0%, 100%, 0.741) 31.7%,
                  hsla(0, 0%, 100%, 0.648) 35.3%,
                  hsla(0, 0%, 100%, 0.55) 38.8%,
                  hsla(0, 0%, 100%, 0.45) 42.5%,
                  hsla(0, 0%, 100%, 0.352) 46.7%,
                  hsla(0, 0%, 100%, 0.259) 51.6%,
                  hsla(0, 0%, 100%, 0.175) 57.7%,
                  hsla(0, 0%, 100%, 0.104) 65.3%,
                  hsla(0, 0%, 100%, 0.049) 74.7%,
                  hsla(0, 0%, 100%, 0.013) 86.1%,
                  hsla(0, 0%, 100%, 0) 100%
                );
                pointer-events: none;
              }

              &::after {
                left: auto;
                right: 0;
                background: linear-gradient(
                  to left,
                  hsl(0, 0%, 100%) 0%,
                  hsla(0, 0%, 100%, 0.987) 9.2%,
                  hsla(0, 0%, 100%, 0.951) 16.7%,
                  hsla(0, 0%, 100%, 0.896) 22.7%,
                  hsla(0, 0%, 100%, 0.825) 27.6%,
                  hsla(0, 0%, 100%, 0.741) 31.7%,
                  hsla(0, 0%, 100%, 0.648) 35.3%,
                  hsla(0, 0%, 100%, 0.55) 38.8%,
                  hsla(0, 0%, 100%, 0.45) 42.5%,
                  hsla(0, 0%, 100%, 0.352) 46.7%,
                  hsla(0, 0%, 100%, 0.259) 51.6%,
                  hsla(0, 0%, 100%, 0.175) 57.7%,
                  hsla(0, 0%, 100%, 0.104) 65.3%,
                  hsla(0, 0%, 100%, 0.049) 74.7%,
                  hsla(0, 0%, 100%, 0.013) 86.1%,
                  hsla(0, 0%, 100%, 0) 100%
                );
              }
            }
          }

          ${media.mobile.down} {
            &--overflow-visible .swiper-wrapper {
              display: flex;
              flex-direction: column;
              transform: none !important;
            }
          }

          ${media.tablet.only} {
            margin: auto;

            &:not(.w-theme) {
              max-width: 655px;
            }
          }

          ${media.mobile.only} {
            &:not(.w-theme) {
              margin-left: 2rem;
              margin-right: 2rem;
            }
          }

          @media(min-width: 1024px) and (max-width: 1224px) {
            padding-left: 2rem;
            padding-right: 1rem;
          }
        }
      }

      .swiper {
        width: 100%;
        display: flex;
        flex-direction: row;
      }
      @media(max-width: 1023px) {
        .swiper {
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
      .swiper.theme-4 {
        padding-top: 1.25rem;

        @media(min-width: 1024px) {
          overflow: visible;
        }

        @media(min-width: 1280px) {
          overflow: hidden;
        }

        .swiper-slide {
          flex: 1;
        }
      }

      .swiper-slide {
        display: flex;
        height: auto;
        align-items: flex-start;
        flex: 0 0 90%;
        ${twoProducts && 'justify-content: center !important;'}

        @media(min-width: 480px) {
          flex: 0 0 calc(60% - 1.25rem);
        }

        @media(min-width: 600px) {
          flex: 0 0 calc(50% - 1.25rem);
        }

        @media(min-width: 768px) {
          flex: 0 0 calc(40% - 1.25rem);
        }

        @media(min-width: 1024px) {
          flex: 0 0 calc(25% - 1.25rem);
        }
      }

      .swiper.theme-1 .swiper-slide {
        padding-top: 2.25rem;
        padding-bottom: 0.25rem;
      }

      .swiper.theme-2 .swiper-slide,
      .swiper.theme-3 .swiper-slide,
      .swiper.theme-4 .swiper-slide {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
      }

      .swiper-autoheight .swiper-wrapper {
        height: auto !important;
      }

      @media(min-width: 1024px) {
        .swiper-autoheight .swiper-wrapper {
          transform: none !important;
        }
      }

      @media(min-width: 1440px) {
        ${
          tabsEnabled &&
          ` .swiper-wrapper {
            transform: none !important;
          }
        }
        `
        }}

        .swiper-navigation {
          position: absolute;
          bottom: 100%;
          left: 0;
          right: 0;
          height: 5rem;
        }

        .swiper-navigation--disabled {
          display: none;
        }

        .swiper-button-next,
        .swiper-button-prev {
          position: absolute;
          z-index: 20;
          margin-top: 0;
          color: inherit;
        }

        .swiper-button-next::after,
        .swiper-button-prev::after {
          font-weight: 700;
          font-size: 1.5rem;
        }

        .swiper-button-next {
          transform: translate(50%, -50%);
          right: calc((100% - 100px) / 2);
        }

        .swiper-button-prev {
          transform: translate(-50%, -50%);
          left: calc((100% - 100px) / 2);
        }

        .swiper-pagination {
          top: 50% !important;
          transform: translateY(-50%);
          bottom: auto !important;
          line-height: 0;
        }

        .swiper-pagination-bullet-active {
          background-color: ${colors.primary.gravity};
        }
      }
    `;
  }};
`;
